// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608211804/js/" + chunkId + "." + {"44":"e201f5bb","225":"60cc020b","481":"98b3f0fc","486":"64d16a28","770":"ceacde46"}[chunkId] + ".0.8775216658855796.chunk.js";
};